var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"xl","hide-footer":"","title":_vm.prefix + _vm.title},on:{"hidden":_vm.fecharModal},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('ConsultarSolicitacaoAlteracaoValor',{attrs:{"prefix":_vm.prefix,"ata":_vm.ata}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }